import styles from '../../AdminTools.module.css'
import { CSSProperties } from 'react'

export interface SparaButtonProps {
  handleClick: () => void
  disabled?: boolean
  style?: CSSProperties
}

export const SparaButton = ({
  handleClick,
  disabled = false,
  style,
}: SparaButtonProps) => {
  return (
    <div className={styles.headerAlignedButton}>
      <button
        className={styles.kontrollButton}
        onClick={handleClick}
        disabled={disabled}
        style={style}
      >
        Spara
      </button>
    </div>
  )
}
